<template>
  <el-button class="btn-confirm" :icon="iconClass" @click="confirm()">{{value}}</el-button>
</template>

<script>
export default {
  name: "button-confirm",
  props: {
    value: {
      type: String,
      default: "确定"
    },
       iconClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped>
.btn-confirm {
  border: 0;
  color: #fff;
  padding: 8px 16px;
  background-color: #1362ff;
  height: 32px;
}
.btn-confirm:focus {
  border: 0;
  color: #fff;
  padding: 8px 16px;
  background-color: #1362ff;
}
.btn-confirm:hover {
  color: #fff;
  background-color: #06b3ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Button/ButtonConfirm.vue